import type { HistogramChartYAxisProps } from '../types/histogram-props.js';

export const YAxis = (props: HistogramChartYAxisProps) => null;

YAxis['displayName'] = 'HistogramChart.YAxis';
